import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { useDefaultStyles } from "hooks/useDefaultTooltip";

/**
 * A custom tooltip component for displaying additional information on hover.
 *
 * @typedef {'bottom'|'left'|'right'|'top'|'bottom-end'|'bottom-start'|'left-end'|'left-start'|'right-end'|'right-start'|'top-end'|'top-start'} PlacementType
 *
 * @param {Object} props - Component props
 * @param {boolean} [props.show=false] - Flag to control whether the tooltip is visible
 * @param {React.ReactNode} props.children - Content to display inside the tooltip
 * @param {string} [props.heading=''] - Heading text to display in the tooltip
 * @param {PlacementType} [props.placement='top'] - Placement of the tooltip relative to the children
 * @returns {JSX.Element|null} The MyToolTip component or null if no children or heading are provided
 */
const MyToolTip = ({ show = false, children, heading = "", placement = "top" }) => {
  if (!children) return null;
  if (!heading) return <span>{children}</span>;

  const defaultStyle = useDefaultStyles();
  const headingStyle = { color: "white", margin: "0px" };

  return (
    <Tooltip arrow placement={placement} classes={defaultStyle} {...(show && { open: show })} title={<h6 style={headingStyle}>{heading}</h6>}>
      <span>{children}</span>
    </Tooltip>
  );
};

export default MyToolTip;
